import { APP_NON_NGROK_DOMAIN } from "@/lib/constants/constants";

export const CONSTANTS = {
  LOGIN_LINK: `${APP_NON_NGROK_DOMAIN}/sign-in`,
  SIGNUP_LINK: `${APP_NON_NGROK_DOMAIN}/sign-up`,
  CALCOM_NAMESPACE: "chat-with-manu-demo",
  CALCOM_BRAND_COLOR: "#000000",
  CALCOM_HIDE_EVENT_TYPE_DETAILS: false,
  CALCOM_LAYOUT: "month_view",
  CALCOM_LINK: "manu-arora-vesr9s/chat-with-manu-demo",
};
